import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface PageLoaderState {
  loading: boolean;
  error: boolean;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class PageLoaderService {
  private loadingSubject = new BehaviorSubject<PageLoaderState>({
    loading: false,
    error: false,
    message: 'Por favor espere...'
  });

  loading$ = this.loadingSubject.asObservable();

  private openedAt = 0;
  private timeout: any;

  private readonly MIN_VISIBLE_MS = 2500;
  private readonly MAX_VISIBLE_MS = 12000; // 12 segundos máximo

  show(message: string = 'Por favor espere...'): void {
    this.openedAt = Date.now();

    clearTimeout(this.timeout);

    this.loadingSubject.next({
      loading: true,
      error: false,
      message
    });

    this.timeout = setTimeout(() => {
      this.loadingSubject.next({
        loading: true,
        error: true,
        message: 'La carga está tardando más de lo normal. Revisa tu conexión e intenta nuevamente.'
      });
    }, this.MAX_VISIBLE_MS);
  }

  hide(): void {
    const elapsed = Date.now() - this.openedAt;
    const remaining = Math.max(this.MIN_VISIBLE_MS - elapsed, 0);

    clearTimeout(this.timeout);

    setTimeout(() => {
      this.loadingSubject.next({
        loading: false,
        error: false,
        message: 'Por favor espere...'
      });
    }, remaining);
  }

  forceHide(): void {
    clearTimeout(this.timeout);

    this.loadingSubject.next({
      loading: false,
      error: false,
      message: 'Por favor espere...'
    });
  }
}